import { render, staticRenderFns } from "./AddRoleMenu.vue?vue&type=template&id=042e6024&scoped=true&"
import script from "./AddRoleMenu.vue?vue&type=script&lang=ts&"
export * from "./AddRoleMenu.vue?vue&type=script&lang=ts&"
import style0 from "./AddRoleMenu.vue?vue&type=style&index=0&id=042e6024&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042e6024",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VCard,VChip,VIcon,VMenu})
